"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_ROUTE_VT_DASH = exports.BASE_ROUTE = exports.APP_MODE = void 0;
exports.APP_MODE = {
    PORTAL: 'DTPortal',
    VTDASH: 'VTDash',
};
exports.BASE_ROUTE = "/".concat(exports.APP_MODE.PORTAL);
exports.BASE_ROUTE_VT_DASH = "/".concat(exports.APP_MODE.VTDASH);
